import { useEffect, useRef, useState, useCallback } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useEQM4010_R01Store } from "./Store_EQM4010_R01";

import { ItemSearchSection } from "./SearchSection_EQM4010_R01";
import { ItemTable } from "./Table_EQM4010_R01";

import { DetailTable_EQM4010_R01 } from "./DetailTable_EQM4010_R01";
import { Content_EQM4010_R01 } from "./Content_EQM4010_R01";
import { useMouseContent } from "src/utils/mouse/mouseContent";
import { ItemDto } from "src/dtos/item/itemDto";
import { AgGridReact } from "ag-grid-react";
import { EQM4010_R01DetailDto, EQM4010_R01HeaderDto } from "./Dto_EQM4010_R01";

export const Container_EQM4010_R01 = () => {
	const [isLoading, setIsLoading] = useState(true);
	const [isDetailMaximized, setIsDetailMaximized] = useState(false);
	const { brandCdList, itemGroupList, itemAccountList, unitList } = useCommonCodeStore();

	const {
		EQM4010_R01Filter, setEQM4010_R01Filter,
		EQM4010_R01PastFilter, setEQM4010_R01PastFilter,
		allCount,
	} = useEQM4010_R01Store();

	const containerRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const RESIZER = {
		code: 'EQM4010_R01',
		type: 'height',
		storageKey: 'EQM4010_R01-split-height',
		min: 5,
		max: 80,
		default: 50
	} as const;

	const gridRef = useRef<AgGridReact<EQM4010_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<EQM4010_R01DetailDto>>(null);

	const {
		handleExcelClick,
		fetchData,
		fetchDetailList,
		defaultEQM4010_R01DetailRow,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	} = Content_EQM4010_R01({
		gridRef,
		detailGridRef,
	});

	const {
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
	});

	return (
		<div className="content-container">
			{/* mst1020filter : {JSON.stringify(EQM4010_R01Filter)}<br />
			mst1020pastfilter : {JSON.stringify(EQM4010_R01PastFilter)}<br /> */}
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => { }}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onInitClick={initContainerData}
				onExcelClick={handleExcelClick}
			/>
			<ItemSearchSection />
			<div className="flex flex-col flex-1 px-[12px] gap-[4px] p-[10px]" ref={containerRef} >
				{!isDetailMaximized && (
					<>
						<div className="w-full" style={{ height: `${splitValue}%` }}>
							<ItemTable gridRef={gridRef} />
						</div>

						<div
							className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
							onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown("UD", e.nativeEvent)}
							onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
						/>
					</>
				)}
				<div className="w-full" style={{ height: isDetailMaximized ? '100%' : `calc(${100 - splitValue}% - 40px)` }}>
					<div className={`w-full h-full`}>
						<DetailTable_EQM4010_R01 
							gridRef={detailGridRef} 
							defaultEQM4010_R01DetailRow={defaultEQM4010_R01DetailRow()} 
							isMaximized={isDetailMaximized}
							onToggleMaximize={() => setIsDetailMaximized(!isDetailMaximized)}
						/>
					</div>
				</div>
			</div>
			<Message />
		</div>
	);
};
